<template>
  <div class="noticeDetail" :style="{'paddingTop': statusBar + 'rem'}">
    <Header title="中国国际贸易单一窗口" :back="true" left="返回" :white="true"/>
    <div class="noticeDetailmain">
      <div class="hd">
        <p class="tittle">{{noticeTitle}}</p>
      </div>
      <!-- <van-divider :style="{ border: '1px #F8F8FC solid', padding: '0 24px' }"></van-divider> -->
      <div style="border: 1px #F8F8FC solid;margin: 16px 24px;"></div>
      <div class="rq">
        <p class="zd" style="float:left;">文章来源：{{publisher}}</p>
        <p class="zd"  style="float:right">发布时间：{{publishtime}}</p>
      </div>
      <div class="nr" >
        <p class="nrp" v-html='noticeContent'></p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Vue from 'vue';
import { Divider } from 'vant';
Vue.use(Divider);
export default {
  name: 'notice',
  /**
   * 初始化数据
   */
  data() {
    return {
      statusBar: 0,
      // noticeTitle:"李克强:推广国际贸易\"单一窗口\" 实现通关一体化",
      // publisher:"电子口岸数据中心",
      // publishtime:"2019/02/15",
      // noticeContent:"3月5日上午9时，第十二届全国人民代表大会第五次会议在人民大会堂举行开幕会，李克强总理作政府工作报告。李克强在报告2017年重点工作任务时说，促进外贸继续回稳向好。落实和完善进出口政策，推动优进优出。扩大出口信用保险覆盖面，对成套设备出口融资应保尽保。设立服务贸易创新发展引导基金。支持市场采购贸易、外贸综合服务企业发展。加快外贸转型升级示范基地建设。促进加工贸易向产业链中高端延伸、向中西部地区梯度转移。推广国际贸易“单一窗口”，实现全国通关一体化。增加先进技术、设备和关键零部件进口，促进贸易平衡发展和国内产业加快升级。<img src='http://t9.baidu.com/it/u=4169540006,4220376401&fm=79&app=86&f=JPEG?w=1000&h=1500' width='100%'  style='margin:10px 0 10px 0'>"

      noticeTitle:"",
      publisher:"",
      publishtime:"",
      noticeContent:""
    }
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
    this.getMobileNoticDetail()
  },
  /**
   * 方法
   */
  methods: {
    /**
     * 获取详情数据
     */
    getMobileNoticDetail(){
       
       let noticeId = `${this.$route.query.noticeId}`
       if("1"===noticeId){
           this.noticeTitle="海关总署 农业农村部公告2021年第15号（关于防止阿尔及利亚高致病性禽流感传入我国的公告）";
           this.publisher="海关总署-海关法规";
           this.publishtime="2021/02/20";
           this.noticeContent="<p>　　近日，阿尔及利亚官方向世界动物卫生组织通报本国家禽发生H5N8亚型高致病性禽流感疫情。为保护我国畜牧业安全，防止疫情传入，根据《中华人民共和国海关法》《中华人民共和国进出境动植物检疫法》等有关法律法规的规定，现公告如下：</p><p>　　一、禁止直接或间接从阿尔及利亚输入禽类及其相关产品（源于禽类未经加工或者虽经加工但仍有可能传播疫病的产品）。</p><p>　　二、禁止寄递或携带来自阿尔及利亚的禽类及其产品入境。一经发现，一律作退回或销毁处理。</p><p>　　三、在进境运输工具（如船舶、航空器、国际列车等）上，如发现来自阿尔及利亚的禽类及其产品，一律作封存处理（自用禽肉除外，但不得带离运输工具），且在我国境内停留或者运行期间，未经海关许可，不得启封动用。其废弃物、泔水等，一律在海关的监督下作无害化处理，不得擅自抛弃。运输工具上如发现禽流感疫情，严格依法对污染或可能污染区域监督实施防疫消毒处理。</p><p>　　四、对边防等部门截获的非法入境的来自阿尔及利亚的禽类及其产品，一律在海关的监督下作销毁处理。</p><p>　　五、凡违反上述规定者，由海关依照《中华人民共和国海关法》《中华人民共和国进出境动植物检疫法》及其实施条例有关规定处理。</p><p>　　六、各海关、各级动物疫病预防控制机构及动物卫生监督机构要分别按照《中华人民共和国海关法》《中华人民共和国进出境动植物检疫法》《中华人民共和国动物防疫法》等有关规定，密切配合，做好检疫、防疫和监督工作。</p><p>　　本公告自发布之日起实施。</p><p>　　特此公告。</p><p style='text-align:right'>海关总署</p><p style='text-align:right'>2021年2月20日</p><p>　　公告正文下载链接：</p><p>　　<a href='http://www.customs.gov.cn/eportal/fileDir/customs/resource/cms/article/302267/3552236/2021022213270436559.doc'>海关总署 农业农村部关于防止阿尔及利亚高致病性禽流感传入我国的公告.doc</a></p";
       }else if("2"===noticeId){
           this.noticeTitle="海关总署公告2021年第14号（关于进口老挝屠宰用肉牛检疫卫生要求得公告）";
           this.publisher="海关总署-海关法规";
           this.publishtime="2021/02/10";
           this.noticeContent="<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;根据我国相关法律法规和《中华人民共和国海关总署和老挝人民民主共和国农业部关于中国从老挝输入屠宰用肉牛的检疫和卫生要求议定书》规定，自本公告发布起，允许符合相关要求的老挝屠宰用肉牛进口。现将进口老挝屠宰用肉牛检疫卫生要求予以公布（见附件）。</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;特此公告</p><p style='text-align:right'>海关总署</p><p style='text-align:right'>2021年2月10日</p><p>　　公告正文下载链接：</p><p>　　<a href='http://www.customs.gov.cn/eportal/fileDir/customs/resource/cms/article/302267/3547700/2021021014534990911.doc'>海关总署 进口老挝屠宰用肉牛检疫卫生要求的公告.doc</a></p";
       }else if("3"===noticeId){
            this.noticeTitle="海关总署公告2021年第13号（关于发布海南离岛旅客免税购物邮寄送达和返岛提取提货方式监管要求的公告）";
            this.publisher="海关总署-海关法规";
            this.publishtime="2021/02/03";
            this.noticeContent="<p>　　为落实海南自由贸易港建设要求，进一步促进海南国际旅游消费中心建设，有效释放离岛免税政策效应，提升离岛旅客免税购物体验感，根据《财政部 海关总署 税务总局关于增加海南离岛旅客免税购物提货方式的公告》（2021年第2号）有关规定，现就海南离岛旅客免税购物邮寄送达和返岛提取提货方式监管要求公告如下：</p><p>　　一、邮寄送达提货方式</p><p>　　（一）离岛旅客购买免税品，购买人、支付人、收件人均为购物旅客本人，且收件地址在海南省外的，可以选择邮寄送达方式提货。</p><p>　　（二）离岛旅客选择邮寄送达方式提货后，离岛免税商店应在核实购物旅客符合邮寄要求且已实际离岛后，一次性寄递旅客所购免税品，向海关实时传输符合海关规定格式且已施加电子签名的免税品交易和购物人员信息、人证信息验核一致、寄递运单、签收信息等电子数据，并对数据真实性承担相应责任。</p><p>　　二、岛内居民返岛提取提货方式</p><p>　　（一）岛内居民（包括持有海南省身份证、海南省居住证或社保卡的中国公民，以及在海南省工作生活并持有居留证的境外人士）在离岛前购买免税品后已返回岛内的，可以在离岛免税商店设立的返岛旅客提货点提取免税品。上述岛内居民应于购买之日起三个月内，持本人有效身份证件和实际离岛行程信息提货。超过规定时限未提货的，免税商店应当主动为其办理退货手续。</p><p>　　（二）离岛免税商店设立的返岛旅客提货点，应按规定验核提货人资格、实际离岛行程信息等电子数据信息无误后将免税品交付购物人，并向海关实时传输符合海关规定格式且已施加电子签名的免税品交易、人证信息验核一致、本人提货签收、离岛行程信息等电子数据，并对数据真实性承担相应责任。</p><p>　　离岛免税商店设立的返岛旅客提货点，应符合海关监管条件，报海关核准。</p><p>　　三、相关法律责任</p><p>　　对于离岛免税商店未尽责审核离岛旅客身份信息和行程信息真实性等，导致出现个人身份信息或年度购买额度被盗用、离岛旅客违规邮寄或提取免税品的，以及未按规定及时准确向海关传输电子数据的，由海关责令其改正，可给予警告；对于在一个公历年度内被海关警告超过3次的，海关可暂停其从事离岛免税经营业务最长不超过6个月。</p><p>　　本公告自公布之日起执行。对海南离岛旅客免税购物邮寄送达和返岛提取提货方式的其他监管事项按照海关总署公告2020年第79号有关规定执行。</p><p>　　特此公告。</p><p style='text-align: right;'>　　海关总署</p><p style='text-align: right;'>　　2021年2月3日</p><p>　　公告正文下载链接：</p><p>　　<a href='http://www.customs.gov.cn/eportal/fileDir/customs/resource/cms/article/302267/3543998/2021020714295351624.doc'>海关总署关于发布海南离岛旅客免税购物邮寄送达和返岛提取提货方式监管要求的公告.doc</a></p>";
       }else if("4"===noticeId){
            this.noticeTitle="海关总署 农业农村部公告2021年第12号（关于防止斯里兰卡牛结节性皮肤病传入我国的公告）";
            this.publisher="海关总署-海关法规";
            this.publishtime="2021/01/28";
            this.noticeContent="p>　　2021年1月19日，世界动物卫生组织（OIE）公布斯里兰卡贾夫纳县（Jaffna）、马纳尔县（Mannar）和瓦武尼亚县（Vavuniya）6家农场发生牛结节性皮肤病疫情，涉及的易感动物有543头牛，其中83头发病，这是斯里兰卡首次发生牛结节性皮肤病疫情。为保护我国畜牧业安全，防止疫情传入，根据《中华人民共和国海关法》、《中华人民共和国进出境动植物检疫法》及其实施条例等有关法律法规的规定，现公告如下：</p><p>　　一、禁止直接或间接从斯里兰卡输入牛及其相关产品（源于牛未经加工或者虽经加工但仍有可能传播疫病的产品）。</p><p>　　二、禁止寄递或携带来自斯里兰卡的牛及其产品入境。一经发现，一律作退回或销毁处理。</p><p>　　三、进境船舶、航空器、公路车辆和铁路列车等运输工具上，如发现有来自斯里兰卡的牛及其产品，一律作封存处理，且在我国境内停留或者运行期间，未经海关许可，不得启封动用。其废弃物、泔水等，一律在海关的监督下做无害化处理，不得擅自抛弃。运输工具上如发现牛结节性皮肤病疫情，严格依法对污染或可能污染区域监督实施防疫消毒处理。</p><p>　　四、加强对来自斯里兰卡交通运输工具媒介昆虫的消杀处理。</p><p>　　五、对边防等部门截获的非法入境的来自斯里兰卡的牛及其产品，一律在海关的监督下作销毁处理。</p><p>　　六、凡违反上述规定者，由海关依照《中华人民共和国海关法》、《中华人民共和国进出境动植物检疫法》及其实施条例有关规定处理。</p><p>　　七、各海关、各级动物疫病预防控制机构及动物卫生监督机构要分别按照《中华人民共和国海关法》《中华人民共和国进出境动植物检疫法》《中华人民共和国动物防疫法》等有关规定，密切配合，做好检疫、防疫和监督工作。</p><p>　　本公告自发布之日起实施。</p><p>　　特此公告。</p><p style='text-align: right;'>　　海关总署　　农业农村部</p><p style='text-align: right;'>　　2021年1月28日</p><p>　　公告正文下载链接：</p><p>　　<a href='http://www.customs.gov.cn/eportal/fileDir/customs/resource/cms/article/302267/3539393/2021020316003473987.doc'>海关总署 农业农村部关于防止斯里兰卡牛结节性皮肤病传入我国的公告.doc</a></p>";
       }else if("5"===noticeId){
            this.noticeTitle="海关总署公告2021年第11号（关于发布《北京2022年冬奥会和冬残奥会海关通关须知》的公告）";
            this.publisher="海关总署-海关法规";
            this.publishtime="2021/01/27";
            this.noticeContent="<p>　　为支持我国举办北京2022年冬奥会和冬残奥会，海关总署研究制定了《北京2022年冬奥会和冬残奥会海关通关须知》（见附件），现予以公布。</p><p>　　特此公告。</p><p>　　附件：<a href='http://www.customs.gov.cn/eportal/fileDir/customs/resource/cms/article/302267/3534521/2021020109285848198.doc'>北京2022年冬奥会和冬残奥会海关通关须知.doc</a></p><p style='text-align: right;'>　　海关总署</p><p style='text-align: right;'>　　2021年1月27日</p><p>　　公告正文下载链接：</p><p>　　<a href='http://www.customs.gov.cn/eportal/fileDir/customs/resource/cms/article/302267/3534521/2021020109291289856.doc'>海关总署关于发布《北京2022年冬奥会和冬残奥会海关通关须知》的公告.doc</a></p>";
       }
      console.log(`${this.$route.query.noticeId}`);

/*
      this.$http.post('zsdyckserver/app/notice/getNoticesById?noticeId='+`${this.$route.query.noticeId}`).then(res => {
        this.noticeTitle = res.resultData.noticeTitle;
        this.publisher = res.resultData.publisher;
        this.publishtime = res.resultData.publishtime;
        this.noticeContent = res.resultData.noticeContent;
      }).catch(err => {
        window.console.log(err)
      })
*/      
    },
   },
  beforeDestroy() {
   // this.$tool.beforeDestroy(1);
  },
  components:{
    Header,
  }
}
</script>

<style scoped lang="scss">
  .noticeDetail{
    text-align: center;
    width: 100%;
    min-height: 100%;
    background: #f7f8fa;
    .noticeDetailmain{
      overflow: auto;
      background: #fff;
      .hd{
        margin:  32px 28px 16px 12px;
        .tittle{
          // font-family:"PingFangSC-Medium";
          // font-weight:600;
          // font-size: 20px;
          // line-height: 25px;
          // text-align:left;
          width:335px;
         // height:45px;
          font-size:18px;
          font-family:"PingFangSC-Medium";
          font-weight:700;
          color:#050F28;
          line-height:27px;
          text-align: left
        }
        
      }
      .rq{      
        height: 20px;
        margin: 0 32px;
        .zd{
          // font-size:11px;
          //  font-family:"PingFangSC-Regular";
          //  line-height: 11px;
          //  color: #A0A5AA;
          height:20px;
          font-size:12px;
          font-family:PingFang SC;
          font-weight: 400;
          color:rgba(160,165,170,1);
          line-height:20px;


        }
      }
      .nr{
        margin: 18px 24px;
        .nrp{
   //         width:327px;
            font-size:14px;
            font-family:PingFang SC;
            font-weight:400;
            color:rgba(5,15,40,1);
            line-height:24px;
            text-align: left;
        }
      }
    }
  } 
</style>

